/**
 * Whether the page is driven by browser automation, i.e. the Playwright suite.
 *
 * `navigator.webdriver` is true exactly when automation controls the browser (WebDriver
 * specification) - Playwright always sets it, a person at a counter never has it. The answer is
 * used for one thing: turning off component animations, which in automation are only a source of
 * clicks landing on a dialog that is still zooming in, and of exit motions that never report their
 * end (`documentation/implementation_progress_e2e_tests.md`, 2026-11-02).
 */
export function isAutomatedBrowser(
    browserNavigator: Pick<Navigator, 'webdriver'> | undefined = globalThis.navigator,
): boolean {
    return browserNavigator?.webdriver === true;
}
